<template>
  <div>
    <div class="d-flex align-items-center" style="gap: 2.34rem; margin-bottom: 1.70rem;">
      <div>
        <!-- <h1 class="title">{{ $t("common.dashboard") }}</h1> -->
      </div>
    </div>

    <div class="rd-">
      <div class="row">
        <div class="col-md-6 text-center" style="height:300px;">
          <h4>{{ $t("risk.dashboard.average-risk") }}</h4>
          <div v-if="dashboard">
            <vue-gauge :refid="'type-unique-id'" :options="gaugeOptions"></vue-gauge>

            <h4 class="">{{ $t("risk.dashboard.average-score") }}: {{ gaugeOptions.needleValue }}</h4>
          </div>
        </div>

        <div class="col-md-6 text-center" v-if="categoryBasedRiskCount.datas && categoryBasedRiskCount.datas">
          <h4>{{ $t("risk.dashboard.category-based-risk-status") }}</h4>
          <doughnut-chart
            class="mt-4"
            style="height:240px"
            :plugins="doughnutPlugins"
            :labels="categoryBasedRiskCount.labels"
            :datas="categoryBasedRiskCount.datas"
            @click="goToRiskList"
          />
        </div>
        <div class="col-md-12 mt-4 ">
          <h4>{{ $t("risk.dashboard.statuses") }}</h4>
          <chartist ratio="ct-chart" :data="organizationRiskStatuses" :options="extoOptions" type="Bar"></chartist>

          <div v-if="organizationRiskStatuses">
            <div class="legend" style="display: inline!important;">
              <div class="legend-item">
                <div class="box bg-primary"></div>
                <span>{{ $t("risk.dashboard.active") }}</span>
              </div>
              <div class="legend-item">
                <div class="box bg-success"></div>
                <span>{{ $t("risk.dashboard.inactive") }}</span>
              </div>
              <div class="legend-item">
                <div style="background-color: #f1b34c;" class="box"></div>
                <span>{{ $t("risk.dashboard.waiting-approval") }}</span>
              </div>
              <!-- <div class="legend-item">
                <div class="box bg-danger"></div>
                <span>{{ $t("risk.dashboard.waiting-approval") }}</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DoughnutChart from "@modules/organization/components/doughnut";
import ChartDataLabels from "chartjs-plugin-datalabels";
import VueGauge from "vue-gauge";

export default {
  components: { DoughnutChart, VueGauge },
  data() {
    return {
      request: {
        options: { page: 1, limit: 15, sort: { name: "asc" } },
        query: {},
      },
      doughnutPlugins: [ChartDataLabels],
      extoOptions: {
        height: 300,

        axisY: {
          offset: 20,
          onlyInteger: true,
        },
        responsiveOptions: [
          // Options override for media > 400px
          [
            "screen and (min-width: 400px)",
            {
              reverseData: true,
              horizontalBars: true,

              axisY: {
                offset: 60,
              },
            },
          ],
          // Options override for media > 800px
          [
            "screen and (min-width: 800px)",
            {
              stackBars: false,
              seriesBarDistance: 10,
            },
          ],
          // Options override for media > 1000px
          [
            "screen and (min-width: 1000px)",
            {
              reverseData: false,
              horizontalBars: false,
              seriesBarDistance: 15,
            },
          ],
        ],
      },
    };
  },
  async mounted() {
    await this.$store.dispatch("organizationRisk/dashboard");
  },
  computed: {
    categoryBasedRiskCount() {
      let labels = [];
      let datas = [];
      if (!this.dashboard) {
        return { labels, datas };
      }

      labels = Object.keys(this.dashboard.categoryBasedRiskCount).map((key) => {
        return this.$t(`risk.category.${key.toLocaleLowerCase()}`);
      });
      datas = Object.values(this.dashboard.categoryBasedRiskCount);

      // if (datas.length == 0) {
      //   labels = [this.$t(`risk.category.technical`), this.$t(`risk.category.administrative`), this.$t(`risk.category.legal`)];
      //   datas = [0, 0, 0];
      // }

      return { labels, datas };
    },
    organizationRiskStatuses() {
      let labels = [];
      let datas = [];
      if (!this.dashboard) {
        return { labels, datas };
      }

      labels = Object.keys(this.dashboard.organizationRiskStatuses);

      const properties = ["active", "inactive", "waitingForApproval"];

      properties.forEach((property) => {
        const column = labels.map((label) => {
          const value = this.dashboard.organizationRiskStatuses[label][property];
          return value === 0 ? 0.1 : value;
        });
        datas.push(column);
      });
      labels = labels.map((i) => {
        return i == "PLATFORM" ? this.$t("common.corporate") : i;
      });
      return { labels, series: datas };
    },

    gaugeOptions() {
      const needleValue = Math.round(this.dashboard.averageRiskPoint);
      const firstDelimiter = this.dashboard.ratingDefinition.medium.min;
      const secondDelimiter = this.dashboard.ratingDefinition.high.min;

      return { needleValue, arcDelimiters: [firstDelimiter, secondDelimiter], arcColors: ["#50ce89", "#ffbd89", "#f46a6a"], rangeLabel: ["0", "75"], chartWidth: 300 };
    },
    dashboard() {
      return this.$store.getters["organizationRisk/dashboard"];
    },
  },

  methods: {
    goToRiskList(event, elements) {
      const clickedIndex = elements[0].index;
      const clickedCategory = Object.keys(this.dashboard.categoryBasedRiskCount)[clickedIndex];

      if (elements && elements.length > 0) {
        this.$router.push({
          path: "/risk/list",
          query: {
            category: clickedCategory,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./organization-risk-decision.scss";

.legend {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.box {
  width: 20px;
  height: 20px;
}
.bg-light-primary {
  background-color: #2ee8e8;
}
</style>
